import type { NavbarSerializableNode } from '@/navbarElement';
import type { NavbarV2SerializableNode } from '@/navbarMenuElement';
import type { InlineNode } from '@/types';
import { produce } from 'immer';

export const navbarV2Migrator = <T extends NavbarSerializableNode | InlineNode = NavbarSerializableNode>(
  navbar: T,
): NavbarV2SerializableNode => {
  const recursiveMigrate = (node: NavbarV2SerializableNode): void => {
    if ('text' in node) return;
    if (node.type === 'hardBreak') return;

    switch (node.type) {
      case 'navbar_item': {
        if (!node.attrs?.label || node.attrs?.type === 'logo') break;

        const labelText = node.attrs?.label || '';

        const textAlreadyExists = node.content?.some((item) => 'text' in item);

        if (textAlreadyExists) break;

        if (node.content) {
          node.content.unshift({
            type: 'text',
            text: labelText,
          } as InlineNode);
        } else {
          node.content = [{ type: 'text', text: labelText } as InlineNode];
        }

        for (const item of node.content ?? []) {
          recursiveMigrate(item);
        }
        break;
      }

      // case 'navbar_menu':
      // case 'navbar_dropdown':
      // case 'navbar_menu_list_group':
      // case 'navbar_dropdown_column':
      // case 'navbar_menu_burger_content':
      // case 'navbar_menu_list':
      // case 'navbar_dropdown_item':
      // case 'navbar_menu_burger':
      default:
        for (const item of node.content ?? []) {
          recursiveMigrate(item);
        }
        break;
    }
  };

  return produce(navbar, recursiveMigrate);
};
